import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "./Services01.css";

import img1 from "./../../../img/services/rk-full-package.jpg";
import img2 from "./../../../img/services/regular-hair-beard.jpg";
import img3 from "./../../../img/services/kids-regular.jpg";
import img4 from "./../../../img/services/zero-fade-taper-fade.jpg";
import img5 from "./../../../img/services/vip-package.jpg";

function Services01() {
  return (
    <div className="Services01 section" id="Services01">
      <div className="container">
        <div className="intro">
          <p className="eyebrow">Services</p>
          <h2>Our Services</h2>
          <p>Book your appointment for a modern cut.</p>
        </div>
        <div className="Services01-box">
          <div className="Services01-card">
            <img src={img1} alt="" />
            <div>
              <h3>RK Full Package</h3>
              <Link to="/" className="small-font">
                Read more
              </Link>
            </div>
            <p>1 hr 30 min</p>
            <p>$79.99</p>{" "}
            <Link to="/book-now" className="small-font btn-2">
              BOOK NOW
            </Link>
          </div>

          <div className="Services01-card">
            <img src={img2} alt="" />
            <div>
              <h3>Regular Hair & Beard</h3>
              <Link to="/" className="small-font">
                Read more
              </Link>
            </div>
            <p>1 hr</p>
            <p>$47.99</p>{" "}
            <Link to="/book-now" className="small-font btn-2">
              BOOK NOW
            </Link>
          </div>

          <div className="Services01-card">
            <img src={img3} alt="" />
            <div>
              <h3>Kids Regular Haircut (12 or under)</h3>
              <Link to="/" className="small-font">
                Read more
              </Link>
            </div>
            <p>30 min</p>
            <p>$32.99</p>{" "}
            <Link to="/book-now" className="small-font btn-2">
              BOOK NOW
            </Link>
          </div>

          <div className="Services01-card">
            <img src={img4} alt="" />

            <div>
              <h3>Zero Fade Or Taper Fade</h3>
              <Link to="/" className="small-font">
                Read more
              </Link>
            </div>

            <p>45 min</p>
            <p>$32.99</p>
            <Link to="/book-now" className="small-font btn-2">
              BOOK NOW
            </Link>
          </div>

          <div className="Services01-card">
            <img src={img5} alt="" />
            <div>
              <h3>VIP Package 1</h3>
              <Link to="/" className="small-font">
                Read more
              </Link>
            </div>
            <p>1 hr 30 min</p>
            <p>$79.99</p>{" "}
            <Link to="/book-now" className="small-font btn-2">
              BOOK NOW
            </Link>
          </div>
        </div>

        <a href="/services" className="btn-3">
          VIEW MORE
        </a>
      </div>
    </div>
  );
}

export default Services01;
